export default "__VITE_ASSET__DeLXkBeZ__"